export interface Testimonial {
  name: string;
  handle: string;
  content: string;
  avatarBg: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Marcus Chen',
    handle: '@marcusfinds',
    content: 'The Superbuy Spreadsheet completely changed how I shop. Found three pairs of sneakers I would have never discovered on my own. The category organization alone saves me hours every week.',
    avatarBg: 'bg-accent-300',
  },
  {
    name: 'Emily Rodriguez',
    handle: '@emily_shops',
    content: 'As someone new to Superbuy, this spreadsheet was a lifesaver. Everything is so well organized and the QC tips helped me avoid a bad purchase. Cannot recommend enough!',
    avatarBg: 'bg-primary-300',
  },
  {
    name: 'James O\'Connor',
    handle: '@jamesoc_fashion',
    content: 'Been using Superbuy for two years and this is hands down the best resource I have come across. The hoodie section alone has 40+ verified finds. Absolute gem of a spreadsheet.',
    avatarBg: 'bg-secondary-300',
  },
  {
    name: 'Sophie Laurent',
    handle: '@sophielaurent',
    content: 'The updated 2026 version is incredible. New categories, fresh links, and the shipping guide section is exactly what international buyers needed. This is the only resource I trust now.',
    avatarBg: 'bg-accent-400',
  },
  {
    name: 'David Kim',
    handle: '@davidk_streetwear',
    content: 'I was wasting so much time searching for quality products. The Superbuy Spreadsheet gave me instant access to curated finds with actual QC photos. My wardrobe has never looked better.',
    avatarBg: 'bg-primary-200',
  },
  {
    name: 'Anna Johansson',
    handle: '@anna_j',
    content: 'Finally a resource that actually understands what international shoppers need. The comparison feature between different sellers is brilliant. This spreadsheet paid for itself in avoided bad purchases.',
    avatarBg: 'bg-secondary-200',
  },
];